<template>
    <div class="employee-purchase-gate" :class="{ block: !compact }">
        <span class="gate-message">{{ message }}</span>
    </div>
</template>

<script setup lang="ts">
// Shown in place of every consumer purchase/Stripe CTA the actor may not press. Single source of
// the gate copy so every surface (dashboard, data brokers, license modals) stays consistent.
//
// The default below is the EMPLOYEE's reason — their company has switched employee self-purchase
// off (employer.can_purchase_pro === false) — and is addressed to them. An admin acting for the
// company is refused for a different reason and has a different remedy, so those surfaces pass
// `useLicensePurchase().employerGateMessage`, which is undefined for a member and so falls back
// here. Keep the override a prop: the reason belongs to the composable that decides it.
withDefaults(
    defineProps<{
        /** Override the default gate copy when a surface needs more context. */
        message?: string;
        /** Inline treatment for replacing a single action button; block treatment for full modal surfaces. */
        compact?: boolean;
    }>(),
    {
        message: 'Ask your company admin to assign you a license',
        compact: false,
    },
);
</script>

<style lang="scss" scoped>
.employee-purchase-gate {
    @apply inline-flex items-center;

    &.block {
        @apply flex w-full justify-center rounded-lg border border-amber-200 bg-amber-50 px-4 py-6 text-center;
    }
}

.gate-message {
    @apply text-zinc-700 text-sm font-medium leading-5;
}
</style>
